import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import classnames from 'classnames';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cmsWidget as CmsWidget } from 'ui/views/widgets/cmsWidget';
 *
 * // render
 * <CmsWidget propName='propValue'/>
 */
export const cmsWidget = ( props ) => {
    return (
        <div className='ui-cms-widget'>
			<div className='ui-cms-widget__header'>

				{ /* title for the modal */ }
				<div className='ui-cms-widget__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
			<div className='ui-cms-widget__body' onScroll={ props.onScroll }>
				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ get( props, 'data.state.values' ) } // default values
                    mode='form'
                    onChangeCallBack={ props.onChangeCallBack }
                    updatFieldsOnChange={ true }
                    key={ get( props, 'data.state.values.categoryType' ) }
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onFormSubmit( values );
                        }
                    } }

                    // isValid={ false }
                >
                    { ( { fields, values, /* isValid, */ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-cms-widget__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    if( get( field, 'config.hide' ) ) {
                                        return null;
                                    }

                                    const fieldClassName = classnames( 'ui-cms-widget__body__form__field', `ui-cms-widget__body__form__${field.name}` );
   
                                    return (
                                        <field.view
                                            className={ fieldClassName }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props.data.options, field.options ) }
                                            config={ field.config }
                                            mask={ field.mask }
                                            closePopoverOnScrollTrigger={ props.closePopoverOnScrollTrigger }
                                        />
                                    );
                                } ) }
                                
                                {/* button actions */}
                                <div className='ui-cms-widget__body__form__actions'>
                                    { map( props.actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                disabled={ 'cancel' !== action.name ? props.disableSubmit : false }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-cms-widget__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => {
                                                    props.closeOverlay();
                                                } : null }
                                                { ...action }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
		</div>
    );
};

// set display name
cmsWidget.displayName = 'cmsWidget';

// set default props
cmsWidget.defaultProps = {};

// prop types
cmsWidget.propTypes = {};
